module.exports = __webpack_public_path__ + "4f97f9b80a4a70986f1f90bcc4e78aba.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-9.png
// module id = 2685
// module chunks = 0